export default "__VITE_ASSET__Bhddn4g6__";